import React, { useEffect, useState, useRef } from "react";
import ReactPaginate from 'react-paginate';
import Header from "../Header";
import Footer from "../Footer";
import Sidebar from "../Sidebar";
import client from "../../api";
import BlockLoader from "../BlockLoader";

const Contacts = (props) => {
    const api = client();
    const limit = 10
    // Variables to build parameters
    const [user, setUser] = useState("")
    const [pageLoader, setPageLoader] = useState(true);
    const [searchQuery, setSearchQuery] = useState("")
    const [contactList, setContactList] = useState("")
    const [status, setStatus] = useState("")
    const [offset, setOffset] = useState(0)
    const [forcePage, setForcePage] = useState(0)


    
    // Page data variables
    const [users, setUsers] = useState([])
    const [contactListSuggestions, setContactListSuggestions] = useState([])
    const [widgetData, setWidgetData] = useState({})
    const [contactsData, setContactsData] = useState([])
    const [totalContacts, setTotalContacts] = useState(0) 

    const getContactShowStatus = (contact) => {
        if (contact.status == "bounced") {
            return "BOUNCED"
        }else if (contact.status == "unsubscribed"){
            return "UNSUBSCRIBED"
        }else{
            // If the contacts is active what its going
            // Check is it added to a campaign
            // console.log(contact)
            if (parseInt(contact.campaign_count) > 0) {
                // If any email is sent to him yet
                if (contact.sent_count > 0){
                    // ok! if email is sent to him what is the last status 
                    // of the emails 
                    if (contact.engaged_count > 0){
                        return "ENGAGED"
                    }else{
                        return "EMAIL SENT"
                    }
                    
                }else{
                    // Ok so its just in campaign but
                    // not yet sent any email
                    return "IN CAMPAIGN"
                }
            }else{  
                // If its not in campaign then its just added 
                return "CREATED"
            }
        }
    }

    // Function to handle the user change event
    const onUserChange = async (e) => {
        setPageLoader(true);
        //console.log(e.target.value)
        setUser(e.target.value)
        // Clear contact list
        setContactList("")
        // Chear search query
        setSearchQuery("")
        // Clear Status
        setStatus("")
        // Set offset back to 0
        setOffset(0)
        // Now load the widget and the contacts data
        await loadWidgetData(e.target.value)
        await loadContactLists(e.target.value)
        await loadContactData(e.target.value, "", "", "", 0, limit)
    }
    // Function to handle the page change event
    const onSearchQueryChange = async (e) => {
        setSearchQuery(e.target.value)

        if (e.target.value.length > 1) {
            // Set offset back to 0
            setOffset(0)
            await loadContactData(user, contactList, e.target.value, status , 0, limit)
        }else if (e.target.value.length == 0) {
            await loadContactData()
        }
    }
    // Function to handle the page change event
    const onPageChange = async (data) => {
        setForcePage(data.selected)
        const newOffset = data.selected * limit
        setOffset(newOffset)
        await loadContactData(user, contactList, searchQuery, status , newOffset, limit)
    }

    const onStatusChange = async (e) => {
        setStatus(e.target.value)
        // Chear search query
        setSearchQuery("")
        // Set offset back to 0
        setOffset(0)
        // Load the whole page now
        await loadContactData(user, contactList, "", e.target.value , 0, limit)
    }

    // Function to handle the select event of contact list from the autocomplete list
    const handleContactListSelect = async (e) => {
        const suggestionId = e.target.value
        // Set contact list
        setContactList(suggestionId)
        // Chear search query
        setSearchQuery("")
        // Clear Status
        setStatus("")
        // Set offset back to 0
        setOffset(0)
        // Load the whole page now
        await loadContactData(user, suggestionId, "", "" , 0, limit)
        
    }

    // Function to get the auto complete options for selecting the contact list
    const loadContactLists = async (user) => {
        const url = "/v1/contactList/search" + (user? "/" + user: "")
        const response = await api.get(url);
        if(response.status === 200 || response.status === 201){
            // If the request is successful set the contact list options
            setContactListSuggestions(response.data.data)
        }else {
            // If the response is unsuccessful then empty the data into it to hide it
            setContactListSuggestions([])
        }
    }
    const handleWidgetClick = (clickedStatus) => {
        return async () => {
            // Clear contact list
            setContactList("")
            // Chear search query
            setSearchQuery("")
            // Clear Status
            setStatus(clickedStatus)
            // Set offset back to 0
            setOffset(0)
            // Now load the contacts data only with the user selected
            await loadContactData(user, "", "", clickedStatus, 0, limit)
        }
    }

    // This function will load the users in the user select field
    const loadUsers = async () => {
        try{
            const response = await api.get('/v1/user/list');
            if(response.status === 200 || response.status === 201){
                const userData = response.data.users_list.map((v,i) => {return {"email":v.email, "name":v.name}})
                setUsers(userData)
            }
        } catch (error){
            if(error.status === 400) notifyError('Bad Request. Unable to fetch Unsubscribers. Please try again.');
        }
    }

    // Get the widget data and set it to widgets if required
    const loadWidgetData = async (email) => {
        try {
            const response = await api.post('/v1/contact/summary',{email});
            if(response.status === 200 || response.status === 201){
                setWidgetData(response.data.data)
            }
        } catch (error) {
            notifyError('Bad Request. Unable to fetch contact summary. Please try again.');
        }
        
    }
    // Get the contacts data and set it to contacts table if required
    const loadContactData = async (email, contact_list, query, status, offset, limit=10) => {
        setPageLoader(true);
        try {
            const postData = {
                limit:limit,
                offset:offset
            }
            if (email) {
                postData["email"] = email
            }
            if (contact_list) {
                postData["contact_list"] = contact_list
            }
            if (query && query.length > 1) {
                postData["query"] = query
            }
            if (status) {
                postData["status"] = status
            }
            const response = await api.post('/v1/contact/search',postData);
            if(response.status === 200 || response.status === 201){
                const contactData = response.data.data
                const totalContacts = response.data.total
                setContactsData(contactData)
                setTotalContacts(totalContacts)
                if( offset == 0){
                    setForcePage(0)
                }
                setPageLoader(false);
            }
        } catch (error) {
            setPageLoader(false);
            notifyError('Bad Request. Unable to fetch contact summary. Please try again.');
        }
    }

    // Load users once at the page load
    useEffect(() => {
        loadUsers()
        loadWidgetData("")
        loadContactLists(null)
        loadContactData("","","","",offset,limit)
    },[]);

    return(<>
        <Header/>
        <div className="main-page">
            <Sidebar/>
            <div className="contacts-wrap">
                <div className="top-section">
                    <h1>All Contacts</h1>
                    <div className="contact-linked">
                        <div className="contact-linked-inner">
                            <div className="search-by">
                                <div className="field-wrap">
                                    <select className="selectbox" onChange={onUserChange} defaultValue="">
                                        <option value="" >All Users</option>
                                        {users.length > 0 && users.map((v,i)=>{
                                            return <option key={i} value={v.email}>{v.name}</option>
                                        })}
                                    </select>
                                </div>
                            </div>
                            <div className="contact-stats">
                                <ul>
                                    <li onClick={handleWidgetClick("")}>
                                        <span className="field-value">{widgetData.total? widgetData.total: "-"}</span> 
                                        <span className="field-label">Total</span>
                                    </li>
                                    <li onClick={handleWidgetClick("in_campaign")}>
                                        <span className="field-value">{widgetData.in_campaign? widgetData.in_campaign:"-" }</span>
                                        <span className="field-label">In Campaign</span>
                                    </li>
                                    <li onClick={handleWidgetClick("engaged")}>
                                        <span className="field-value">{widgetData.engaged?widgetData.engaged:"-"}</span> 
                                        <span className="field-label">Engaged</span>
                                    </li>
                                    <li onClick={handleWidgetClick("has_leads")}>
                                        <span className="field-value">{widgetData.leads?widgetData.leads:"-"}</span>  
                                        <span className="field-label">Leads</span>
                                    </li>
                                    <li onClick={handleWidgetClick("bounced")}>
                                        <span className="field-value">{widgetData.bounced?widgetData.bounced:"-"}</span>
                                        <span className="field-label">Bounces</span>
                                    </li>
                                    <li onClick={handleWidgetClick("unsubscribed")}> 
                                        <span className="field-value">{widgetData.unsubscribed ? widgetData.unsubscribed: "-"}</span> 
                                        <span className="field-label">Unsubscribes</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="list-with-filter-wrap">
                    <div className="filter-wrap">
                        <div className="field-wrap">
                            <label className="label-xs">Search</label>
                            <input type="text" placeholder="Type email" value={searchQuery} onChange={onSearchQueryChange}/>
                        </div>
                        <div className="field-wrap">
                            <label className="label-xs">Filter</label>
                            <select className="selectbox" onChange={onStatusChange} value={status}>
                                <option value="">All Contacts</option>
                                <option value="in_campaigns">Is in campaign</option>
                                <option value="sent">Email Sent</option>
                                <option value="open">Has opened</option>
                                <option value="click">Has clicked</option>
                                <option value="reply">Has replied</option>
                                <option value="has_leads">Has leads</option>
                                <option value="engaged">Has engaged</option>
                                <option value="bounced">Bounced</option>
                                <option value="unsubscribed">Unsubscribed</option>
                            </select>
                        </div>
                        <div className="field-wrap autocomplete-container">
                            <label className="label-xs">List</label>
                            <select className="selectbox" onChange={handleContactListSelect} value={contactList}>
                                <option value="">All Contact Lists</option>
                                {contactListSuggestions && contactListSuggestions.length && contactListSuggestions.length > 0 && contactListSuggestions.map((suggestion, index) => (
                                    <option key={index} value={suggestion.id}>{suggestion.name}</option>
                                ))}
                            </select>
                            {/* <input type="text" className="autocomplete-input" value={contactListInput} placeholder="List" onChange={handleContactListInputChange}/>
                            {showAutoComplete && contactListSuggestions.length > 0 && (
                                <ul className="autocomplete-suggestions">
                                {contactListSuggestions.map((suggestion, index) => (
                                    <li key={index} onClick={() => handleContactListSuggestionClick(suggestion)} className="autocomplete-suggestion">
                                        {suggestion.name}
                                    </li>
                                ))}
                                </ul>
                            )} */}
                        </div>
                        {/* <div className="field-wrap2">
                            <span className="refresh-icon">
                            <i className='bx bx-refresh' ></i>
                            </span>
                        </div> */}
                    </div>
                     
                    <>
                    {pageLoader ? <div className="block-loader" style={{minHeight:'550px', width:'100%',background:'#fff'}}><BlockLoader /></div> : (contactsData.length > 0 && <table>
                        <thead>
                            <tr>
                                {/* <th>
                                    <input type="checkbox" className="select-all" />
                                </th> */}
                                <th className="align-left">Email</th>
                                <th className="align-left">Created</th>
                                <th>Status</th>
                                <th>Campaign</th>
                                <th>Sent</th>
                                <th>Engaged</th>
                            </tr>
                        </thead>
                        <tbody>
                            {contactsData.length > 0 && contactsData.map((v, i) => {
                                return <tr key={i}>
                                    <td className="align-left">{v.email}</td>
                                    <td className="align-left">{(new Date(v.created_at)).toLocaleDateString()}</td>
                                    <td>{getContactShowStatus(v)}</td>
                                    <td>{v.campaign_count}</td>
                                    <td>{v.sent_count}</td>
                                    <td>{v.engaged_count}</td>
                                </tr>
                            })}
                        </tbody>
                    </table>)}
                    { contactsData.length > 0 && totalContacts > limit && <ReactPaginate 
                        breakLabel="..." 
                        nextLabel="next >" 
                        pageRangeDisplayed={5} 
                        previousLabel="< previous"
                        pageCount={Math.max(1, Math.ceil(totalContacts/limit))}
                        onPageChange={onPageChange}
                        containerClassName="pagination"
                        activeClassName="active"
                        disabledClassName="disabled"
                        forcePage={forcePage}
                    />}
                    </>
                    {!pageLoader && contactsData.length === 0 && <div style={{padding:"auto", margin: "100px", textAlign:"center" }}>There are no contacts to show right now.</div>}

                </div>


            </div>
        </div>
        <Footer/>
    </>);

}

export default Contacts;